import { render, staticRenderFns } from "./project_select.vue?vue&type=template&id=65082a9a&"
import script from "./project_select.vue?vue&type=script&lang=js&"
export * from "./project_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports